<template>
  <el-dialog
    :visible.sync="reviewVisible"
    :show-close="false"
    :close="back"
    :close-on-click-modal='false'
    :close-on-press-escape='false'>
    <div class="back">
      <div class="tag" @click="back"><i class="el-icon-arrow-left"></i>Back</div>
    </div>
    <div class="main">
      <div class="content" v-if="action">After agreeing to the refund, the ShopVidi platform will refund the retailer within 1-3 working days</div>
      <div class="content" v-if="!action">If you disagree with the refund, you can negotiate with the retailer to revise the refund and re-initiate</div>
      <div class="reason" v-if="!action">
        <div class="title">Denial Reason</div>
        <el-input
          type="textarea"
          placeholder="Please enter denial reason"
          v-model="reason"
          maxlength="500"
          show-word-limit
          @input="checkReason"
        />
        <div class="tips" v-if="showTips">Please enter denial reason</div>
      </div>
      <div class="flex_all">
        <el-button
          v-if="action"
          type="primary"
          class="back_button"
          @click="reviewServiceOrder"
          >Confirm Refund</el-button
        >
        <el-button
          v-if="!action"
          type="primary"
          class="back_button"
          @click="reviewServiceOrder"
          >Refusing a refund</el-button
        >
        </div>
    </div>
  </el-dialog>
</template>

<script>
import { putAction } from '@/api/manage.js'
export default {
  props: {
    reviewVisible: {
      type: Boolean,
      default: false
    },
    action: {
      type: Boolean,
      default: false
    },
    reason: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showTips: false
    }
  },
  methods: {
    checkReason(value) {
      if (value) {
        this.showTips = false
      }
    },
    reviewServiceOrder() {
      if (this.action) {
        this.$emit('reviewServiceOrder')
      } else {
        if (!this.reason) {
          this.showTips = true
          return
        }
        this.$emit('reviewServiceOrder', this.reason)
      }
    },
    back() {
      this.reason = ''
      this.$emit('back')
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog{width:480px}
/deep/ .el-textarea__inner{min-height: 60px !important; }
.main{
  width: 90%;margin: 0 auto;
}
.reason{
  .title{
    margin:10px 0;
    font-size: 14px;
    font-family: Satoshi;
    font-weight: 400;
    line-height: 18px;
    color: #262B2F;
    opacity: 1;
  }
  .tips{
    color:red;
    font-size: 12px;
  }
  margin-top: 30px;
}
.back{
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #262B2F;
  font-size: 20px;
  font-family: Satoshi-Medium !important;
  font-weight: 800;
  color: #000000;
  .tag{
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 800;
    color: #262B2F;
  }
}
.back_button {
  width: 164px;
  height: 41px;
  border: 1px solid #707070;
  border-radius: 3px;
  margin: 30px 0;
  background: #000000;
}
.content{
  height: 46px;
  font-size: 15px;
  font-family: Satoshi-Medium !important;
  font-weight: 400;
  line-height: 30px;
  color: #262B2F;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/service-order/components/review-dialog.vue